import { render, staticRenderFns } from "./data-subject-preferences-edit.vue?vue&type=template&id=0f62c8f5"
import script from "./data-subject-preferences-edit.vue?vue&type=script&lang=js"
export * from "./data-subject-preferences-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports